import { render, staticRenderFns } from "./SceltaLentiGrv.vue?vue&type=template&id=e0c7b4d6"
import script from "./SceltaLentiGrv.vue?vue&type=script&lang=js"
export * from "./SceltaLentiGrv.vue?vue&type=script&lang=js"
import style0 from "./SceltaLentiGrv.vue?vue&type=style&index=0&id=e0c7b4d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports